import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: false,
})
export class ClickOutsideDirective implements OnInit {
  @Input() ignoreClass: string[] = [];
  @Input() ignoreModal = true;
  @Output() outside = new EventEmitter<void>();

  private clicks = 0;

  constructor(private el: ElementRef) {}

  ngOnInit() {}

  get element() {
    return this.el.nativeElement as HTMLElement;
  }

  isModalIgnored() {
    return this.ignoreModal && document.querySelector('modal-container');
  }

  @HostListener('document:click', ['$event.target'])
  click(target: HTMLElement) {
    const outSide = !this.element.contains(target);
    const ignoreClass = this.ignoreClass.some((className) =>
      target.className.includes(className),
    );

    if (outSide && this.clicks > 0 && !ignoreClass && !this.isModalIgnored()) {
      this.outside.emit();
    }

    this.clicks++;
  }
}
